const e = {
  mappings: {
    moveForward: ["KeyW", "ArrowUp"],
    moveBackward: ["KeyS", "ArrowDown"],
    moveLeft: ["KeyA", "ArrowLeft"],
    moveRight: ["KeyD", "ArrowRight"],
    moveUp: ["KeyE"],
    moveDown: ["KeyQ"],
    jump: ["Space"],
    primaryAction: ["MouseLeft"],
    secondaryAction: ["MouseRight"]
  },
  bufferWindow: 100,
  gracePeriods: {
    coyoteTime: 100,
    landingBuffer: 50
  },
  mouseSensitivity: {
    look: 0.5,
    scroll: 0.01
  }
};
export {
  e as INPUT_CONFIG
};
//# sourceMappingURL=config.js.map
